import React from "react";
import {Col, Form, InputNumber, Row, Select} from 'antd';
import PropTypes from 'prop-types';

import {userIsStaff} from '../../lib/role';

import {formItemFullWidth} from "../../assets/styles";

const StoredCreditCardForm = ({creditCard}) => {
    const isStaff = userIsStaff();

    return <>
        <Row className="form-item-label">
            Stored Card
        </Row>
        <Row>
            <Select
                defaultValue="primary"
                showArrow={false}
                className="select-in-form"
                dropdownMatchSelectWidth={false}
            >
                <Select.Option value="primary">
                    {creditCard.type} ending in {creditCard.l4d} expires {creditCard.expiry}
                </Select.Option>
            </Select>
        </Row>
        {
            !isStaff &&
            <Form.Item
                name="CVC"
                label="CVC"
                rules={
                    [{
                        required: true,
                        min: 3,
                        max: 4,
                        transform: (val) => {
                            if (val === undefined || val === null) {
                                return '';
                            }
                            return val.toString();
                        }
                    }]
                }
            >
                <Row gutter={{sm: 0, md: 16}}>
                    <Col xs={24} md={12}>
                        <InputNumber
                            placeholder="3 or 4-digit code"
                            maxLength={4}
                            style={{...formItemFullWidth}}
                        />
                    </Col>
                </Row>
            </Form.Item>
        }
    </>
};

export default StoredCreditCardForm;

StoredCreditCardForm.propTypes = {
    creditCard: PropTypes.shape({
        type: PropTypes.string.isRequired,
        l4d: PropTypes.string.isRequired,
        expiry: PropTypes.string.isRequired,
    }).isRequired,
}